import React from 'react'
import styles from './SearchBar.scss'
import { FiltersPopover } from 'features/search/FiltersPopover'
import { CTA } from 'common/styleguide/CTA'
import { Icon } from 'common/Icon'
import { CircleSpinner } from 'common/spinners'
import { featureNames } from 'lib/localization'
import _ from 'lodash'
import { FormattedMessage as T } from 'react-intl'

export class SearchBar extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      keywords: props.query.get('keywords', ''),
      filtersExpanded: false
    }
    this.debouncedKeywordUpdate = _.debounce(this.doSearch, 350)
  }

  componentDidMount = () => {
    this.keywordInput.focus()
  }

  doSearch = (params) => {
    const { doSearch, query } = this.props
    const { keywords } = this.state
    const queryWithUpdates = query.merge(Object.assign({ keywords: keywords, sort_by: '' }, params)) // Keyword search results are always better sorted by relevance
    doSearch(queryWithUpdates)
  }

  onKeywordChange = (e) => {
    this.setState({ keywords: e.target.value }, this.debouncedKeywordUpdate)
  }

  uploadFileClicked = () => {
    this.props.fileInputRef.click()
  }

  toggleFiltersPopover = () => {
    const { filtersExpanded } = this.state
    this.setState({ filtersExpanded: !filtersExpanded })
  }

  render () {
    const { query, doSearch, metricUnits, currentUser, filename, loadFile, uploadPending, intl } = this.props
    const { keywords, filtersExpanded } = this.state

    return (
      <div className={styles.SearchBar}>
        <div className={styles.searchBox}>
          <input
            className={styles.searchInput}
            type='text'
            placeholder={intl.formatMessage(featureNames.search)}
            value={filename || keywords}
            ref={(input) => { this.keywordInput = input }}
            onChange={this.onKeywordChange} />
        </div>
        {loadFile && <CTA
          inline
          secondary
          margins={false}
          disabled={uploadPending}
          className={styles.filterButton}
          onClick={() => !uploadPending && this.uploadFileClicked()}>
          <div className={styles.uploadFile}>
            {uploadPending
              ? <CircleSpinner size={20} />
              : <T id='SearchBar.uploadFile' defaultMessage='Upload File' />}
          </div>
        </CTA>}
        <div className={styles.filter}>
          <CTA
            inline
            secondary
            margins={false}
            className={styles.filterButton}
            ref={r => { this._filtersButton = r }}
            onClick={() => this.toggleFiltersPopover()}>
            <Icon i={'filter'} size={13} />&nbsp;<T id='SearchBar.filter' defaultMessage='Filter' />
          </CTA>
        </div>
        {filtersExpanded && <FiltersPopover
          intl={intl}
          target={this._filtersButton}
          doSearch={doSearch}
          onRequestClose={this.toggleFiltersPopover}
          metricUnits={metricUnits}
          currentUser={currentUser}
          query={query} />}
      </div>
    )
  }
}
